module.exports = __webpack_public_path__ + "static/media/phones.489a6065.png";